module.exports = __webpack_public_path__ + "static/media/03.287fad63.png";